
/* styles */
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-4f8cadfe!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./ImgPreview.vue")
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-4f8cadfe&scoped=true!../../../node_modules/vue-loader/lib/selector?type=styles&index=1!./ImgPreview.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./ImgPreview.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-4f8cadfe!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./ImgPreview.vue"),
  /* scopeId */
  "data-v-4f8cadfe",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/imgPreview/ImgPreview.vue
// module id = 1491
// module chunks = 3